<table #table class="choice-selector">
  @for (row of choices | chunk: columns; track row; let i = $index) {
    <tr>
      @for (choice of row; track choice; let j = $index) {
        <td
          cmChoiceSelectorChoice
          [choice]="choice"
          [isCurrentChoice]="currentChoice && currentChoice.id === choice.id"
          [choiceWidth]="choiceWidth"
          [choiceHeight]="choiceHeight"
          [iconWidth]="iconWidth"
          [iconHeight]="iconHeight"
          [focused]="columns === 1 ? i === 0 : i === 0 && j === 0"
          [showAvatar]="showAvatar"
          [avatarSize]="avatarSize"
          [showIcon]="showIcon"
          [showToggle]="showToggle"
        ></td>
      }
    </tr>
  }
</table>
